module.exports = __webpack_public_path__ + "static/media/fondo_mago.ff8a285b.jpg";